import * as React from "react";
import { SimpleForm, TextInput, Create, SelectInput, PasswordInput } from "react-admin";
import { getAllRoles, ensureWarehouseRole } from "./roles";

// Transform function to format data for the API
const transform = (data) => {
  // Ensure roles is always an array
  const roles = Array.isArray(data.roles) ? data.roles : [data.roles];
  
  return {
    ...data,
    roles: roles,
  };
};

export const UserCreate = (props) => {
  // Get all roles including dynamically created ones
  const allRoles = React.useMemo(() => {
    // First ensure all warehouse roles exist
    const warehouses = JSON.parse(localStorage.getItem("availableWarehouses") || "[]");
    if (Array.isArray(warehouses)) {
      warehouses.forEach(warehouse => {
        ensureWarehouseRole(warehouse);
      });
    }
    
    // Then get all roles including the newly created ones
    return getAllRoles();
  }, []);
  
  // Create role choices for the dropdown
  const roleChoices = Object.entries(allRoles).map(([key, value]) => {
    // Format the display name (capitalize first letter of each word)
    const displayName = key.replace(/([A-Z])/g, ' $1')
                         .replace(/^./, str => str.toUpperCase());
    return { id: value, name: displayName };
  });

  return (
    <Create 
      title="Create new user" 
      warnWhenUnsavedChanges 
      {...props}
      transform={transform}
    >
      <SimpleForm>
        <SelectInput
          label="Select Role"
          source="roles"
          fullWidth
          required
          choices={roleChoices}
        />

        <TextInput fullWidth source="username" required />
        <TextInput fullWidth source="firstName" required />
        <TextInput fullWidth source="lastName" required/>
        <PasswordInput fullWidth source="password" required />
      </SimpleForm>
    </Create>
  );
};